import { mapActions } from 'vuex';

export default {
    methods: {
        ...mapActions({
            DGFiPFetch: 'fetch/DGFiPFetch',
            login: 'user/login',
            logout: 'user/logout',
            throwUnauthorised: 'error/unAuthorised',
            throwNotAuthenticated: 'error/notAuthenticated',
            resetError: 'error/reset',
            pushError: 'error/pushError',
        }),
    },
};